/* 利用形態区分 */
export default {
    // 強制
    FORCED: "01",
    // 任意
    ANY: "02"
}